import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { License, Order } from '../../api/api-generated';
import { Item } from '../../utils/sharedTypes';
import SupportPurchasesOptionsBarForOrder from './SupportPurchasesOptionsBarForOrder';
import SupportPurchasesOptionsBarForSoftwareSold from './SupportPurchasesOptionsBarForSoftwareSold';
import SupportPurchasesTable from './SupportPurchasesTable';

interface Props {
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  license?: License;
  order?: Order;
}

const SupportPurchasesDialog = ({
  dialogOpen,
  setDialogOpen,
  license,
  order,
}: Props) => {
  const [selectedSupportPurchases, setSelectedSupportPurchases] = useState<
    Item[]
  >([]);
  return (
    <Dialog
      fullWidth
      maxWidth='lg'
      open={dialogOpen}
      aria-labelledby='form-dialog-title'
    >
      <DialogTitle>Manage Support Purchase Records</DialogTitle>
      <DialogContent>
        <Typography variant='subtitle2' style={{ marginBottom: '1rem' }}>
          {license &&
            `Support for ${license.company.companyName} and ${license.software.type}`}
          {order && `Support records for Order ${order.purchaseOrderName}`}
        </Typography>
        <SupportPurchasesTable
          setSelectedSupportPurchases={setSelectedSupportPurchases}
          extraFilters={{
            license: license,
            order: order,
            excludeLicense: false,
            excludeOrder: false,
          }}
        />
        {license && (
          <SupportPurchasesOptionsBarForSoftwareSold
            selectedSupportPurchases={selectedSupportPurchases}
            setSelectedSupportPurchases={setSelectedSupportPurchases}
            license={license}
          />
        )}
        {order && (
          <SupportPurchasesOptionsBarForOrder
            selectedSupportPurchases={selectedSupportPurchases}
            setSelectedSupportPurchases={setSelectedSupportPurchases}
            order={order}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDialogOpen(false);
            setSelectedSupportPurchases([]);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SupportPurchasesDialog;
